import api, { ApiResponse, QueryPayload, QueryResponse, WhereCondition } from './api';

export interface ConversionType {
  id: string;
  workspace_id: string;
  name: string;
  event_keys: string[];
  include_in_conversions: boolean;
  include_in_revenue: boolean;
  status: string;
  created_at: string;
  updated_at: string;
}

export const conversionTypesService = {
  query: async (filters: { limit?: number; offset?: number; where?: WhereCondition } = {}): Promise<{ data: ConversionType[]; total: number }> => {
    const payload: QueryPayload = {
      offset: filters.offset ?? 0,
      limit: filters.limit ?? 100,
      order_by: 'conversion_type.created_at',
      order: 'desc',
      ...(filters.where && { where: filters.where }),
    };
    const response = await api.post<QueryResponse<ConversionType>>('/conversion-types/query', payload);
    return { data: response.data.data, total: response.data._meta?.total ?? 0 };
  },

  getById: async (id: string): Promise<ConversionType> => {
    const response = await api.get<ApiResponse<ConversionType>>(`/conversion-types/${id}`);
    return response.data.data!;
  },

  create: async (data: Partial<ConversionType>): Promise<ConversionType> => {
    const response = await api.post<ApiResponse<ConversionType>>('/conversion-types', data);
    return response.data.data!;
  },

  update: async (id: string, data: Partial<ConversionType>): Promise<ConversionType> => {
    const response = await api.patch<ApiResponse<ConversionType>>(`/conversion-types/${id}`, data);
    return response.data.data!;
  },

  delete: async (id: string): Promise<void> => {
    await api.delete(`/conversion-types/${id}`);
  },

};
